import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./LogIn.module.css";
import { useContext, useState } from "react";
import { AuthContext } from "../../shared/Contexts/Auth/AuthContext";
import api from "../../api/api";
import { useFormik } from "formik";
import * as Yup from "yup";

const LogIn = () => {
  const { setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [authError, setAuthError] = useState("");

  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  const query = useQuery();
  const fileUrl = query.get("fileUrl");

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Dirección de correo electrónico no válida")
        .required("Campo obligatorio"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Campo obligatorio"),
    }),
    onSubmit: async (values) => {
      setAuthError(""); // Сброс ошибки перед новой попыткой
      try {
        await api.login(values);

        if (fileUrl) {
          const link = await api.getTemporaryLinkToFile({ fileUrl });
          window.location.href = link.signedUrl;
          return;
        }

        setIsLoggedIn(true);
        navigate("/");
      } catch (error) {
        setAuthError("Correo electrónico o contraseña no válidos");
        console.log(error);
      }
    },
  });

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={formik.handleSubmit}>
        <input
          className={styles.input}
          placeholder="Enter your email"
          type="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.email && formik.errors.email && (
          <div className={styles.textWarning}>{formik.errors.email}</div>
        )}

        <input
          className={styles.input}
          placeholder="Enter your password"
          name="password"
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className={styles.textWarning}>{formik.errors.password}</div>
        )}

        {authError && <div className={styles.textWarning}>{authError}</div>}

        <button className={styles.confirmButton} type="submit">
          Log In
        </button>

        <Link to={"/signin"} className={styles.redirectLink}>
          Don't have an account?{" "}
          <span className={styles.highlightedText}>Sign In</span>
        </Link>
      </form>
    </div>
  );
};

export default LogIn;
